package fr.frux.navigation

import fr.frux.core.maps.MapCameraPosition
import fr.frux.feature.map.DEFAULT_CAMERA
import kotlin.math.abs

/** Sous ce seuil, le centre est celui de la caméra par défaut (arrondis flottants après un aller-retour). */
internal const val DEFAULT_CAMERA_CENTER_TOLERANCE_METERS = 1.0
internal const val DEFAULT_CAMERA_ZOOM_TOLERANCE = 0.01f

private fun MapCameraPosition.isDefaultCamera(): Boolean =
    target.distanceMetersTo(DEFAULT_CAMERA.target) < DEFAULT_CAMERA_CENTER_TOLERANCE_METERS &&
        abs(zoom - DEFAULT_CAMERA.zoom) < DEFAULT_CAMERA_ZOOM_TOLERANCE

/**
 * Route d'ajout depuis la caméra de la carte persistante (ADR 0009). La caméra par défaut n'est
 * pas une zone choisie, c'est le repli d'une carte jamais déplacée : la transmettre ouvrirait le
 * assistant sur Paris au lieu de la caméra persistante de la carte. Elle ne fournit donc aucun centre.
 */
fun addTreeRouteFrom(
    camera: MapCameraPosition?,
    origin: AddTreeOrigin,
    guideRead: Boolean = false,
): Route.AddTree {
    val zone = camera?.takeUnless { it.isDefaultCamera() }
    return Route.AddTree(
        latitude = zone?.target?.latitude,
        longitude = zone?.target?.longitude,
        zoom = zone?.zoom,
        origin = origin,
        guideRead = guideRead,
    )
}
